import { render, staticRenderFns } from "./allocation-list-page.html?vue&type=template&id=13dc57c3&"
import script from "./allocation-list-page.ts?vue&type=script&lang=ts&"
export * from "./allocation-list-page.ts?vue&type=script&lang=ts&"
import style0 from "./allocation-list-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports